//import foo from './bar'

import { slick } from 'slick-carousel/slick/slick.min.js'; // eslint-disable-line import/no-unresolved, no-unused-vars

import(
	/* webpackChunkName: "sportradar-scoreboard" */
	'../../../../../plugins/arsenal-sportradar/assets/js/scoreboard' )
	.then( ( { default: ScoreBoard } ) => {
		ScoreBoard.init();
	} );

import(
	/* webpackChunkName: "header-sticky" */
	'./components/sticky-header'
);

import(
	/* webpackChunkName: "footer-ad" */
	'./components/footer-ad'
);

import(
	/* webpackChunkName: "shows-format-time" */
	'./global/shows-format-time'
);

/**
 * Initialize Mobile navigation. In NESN, dependent on the View.
 *
 * Doing the logic this way leads to an empty fist clause, but it's easier to follow
 */
if ( '1' === window.arsenalVars.isNESN && 'app' === window.arsenalVars.nesnView ) {
} else {
	import(
		/* webpackChunkName: "header-mobile-navigation" */
		'./components/header-main-mobile-navigation'
	);
}

if ( 'app' !== window.arsenalVars.nesnView ) {
	import(
		/* webpackChunkName: "footer-mobile-menu" */
		'./components/footer-mobile-sticky-navigation' )
		.then( ( { default: FooterMobileMenu } ) => {
			FooterMobileMenu.init();
		} );
}
